export const translationZH = {
  top: {
    text_1: '新鲜食物与更好的地球',
    text_2: '人工智能推荐',
    text_3: '数以千计的食谱',
    text_4: '一个帮助您管理食材的地方',
    text_5: '来自多种美食的食谱、',
    text_6: '每周菜单、购物清单',
  },
  main_function: {
    text_1: '主要功能',
    text_1_1: '保持食物新鲜！',
    text_1_2: '通过新鲜度检测提醒，避免浪费食物',
    text_2_1: 'AI食谱建议',
    text_2_2: '根据您冰箱中剩余的食材，发现来自世界各地的食谱',
    text_3_1: '全周菜单',
    text_3_2: '为整周创建菜单',
    text_4_1: '购物清单',
    text_4_2: '创建和更新购物清单，为购物行程做好准备',
    text_5: '下载',
    text_6: 'iFridge 将帮助您',
    text_7_1: '成为更优秀的家庭主妇',
    text_7_2: '减少浪费，打造更健康的地球',
    text_7_3: '享受烹饪乐趣',
  },
  rate_box: {
    text_1: '用户评价',
  },
  faqs: {
    text_1: '常见问题',
    text_2_1: '有哪些类型的账户？我可以免费使用这个应用吗？',
    text_2_2: `您可以在第一个月免费且无广告地使用应用程序的所有功能。
      <br /><br />第一个月后，您的账户将自动变为免费账户。
      <br /><br />免费账户允许您使用应用的基本功能，例如：管理食材、每日食材状态报告。但您无法使用一些高级功能，例如：AI食谱建议、每周菜单、购物清单。使用应用时还会出现广告。
      <br /><br />若要使用应用的所有功能且没有广告，您需要以非常合理的月费升级为高级账户。`,
    text_3_1: '高级账户的费用是多少？',
    text_3_2: `您可以按月或按年订阅。
      <br /><br />月费用：$0.99/月。
      <br /><br />年费用：$9.99/年。
      <br /><br />无其他费用。`,
    text_4_1: '我可以在不付费的情况下订阅高级账户吗？',
    text_4_2: `您完全可以。
      <br /><br />要订阅高级账户，您可以使用 iFridge 积分。
      <br /><br />通过 App Store/Google Play 购买 iFridge 积分：在设置屏幕上，点击积分菜单进入积分购买页面。
      <br /><br />或者，您可以通过观看广告赚取 iFridge 积分：在设置屏幕上，点击其他设置菜单，然后点击观看广告。`,
    text_5_1: '观看广告是否会获得 iFridge 积分？',
    text_5_2: `观看广告可以获得 iFridge 积分。
      <br /><br />根据您的国家，每次观看广告都会获得一定数量的 iFridge 积分（依据 Google Admob 的规定）。观看广告后，您需要等待 20 分钟才能观看下一条广告。`,
    text_6_1: '我可以通过推荐朋友赚取 iFridge 积分吗？',
    text_6_2: `通过推荐朋友，您完全可以获得 iFridge 积分。
      <br /><br />根据您的国家，当您通过 Facebook、Twitter 等社交网络分享 iFridge 的信息时，可以获得一定数量的 iFridge 积分。
      <br /><br />一个月内，您仅能通过推荐获得一次 iFridge 积分。`,
    text_7_1: '我的个人数据是否存储安全？是否会与第三方共享？',
    text_7_2:
      '您的数据完全存储在您的手机上，并且是完全安全的。我们不会将您的个人数据存储在我们的服务器上，也不会与任何第三方共享您的个人数据。',
    text_8_1: '如果我需要支持，该如何联系？',
    text_8_2: `您可以通过联系我们功能进行联系：在设置屏幕上，选择其他设置，然后选择联系我们。
      <br /><br />或者直接将支持请求/反馈发送至邮箱：ifridge.foodie@gmail.com`,
  },
  footer: {
    text_1: '爱可能来来去去，',
    text_2: '但饥饿每天都会造访',
  },
};
